import { gql } from '@apollo/client';

export const CREATE_EQUIPMENT = gql`
  mutation createEquipment($name: String!, $description: String, $size: String) {
    createEquipment(name: $name, description: $description, size: $size) {
      id
      name
      description
      size
    }
  }
`;

export const UPDATE_EQUIPMENT = gql`
  mutation updateEquipment($id: Int!, $name: String, $description: String, $size: String) {
    updateEquipment(id: $id, name: $name, description: $description, size: $size) {
      id
      name
      description
      size
    }
  }
`;

export const DELETE_EQUIPMENT = gql`
  mutation deleteEquipment($id: Int!) {
    deleteEquipment(id: $id) {
      id
    }
  }
`;

export const ASSIGN_EQUIPMENT_TO_BAG = gql`
  mutation assignEquipmentToBag($bagId: Int!, $equipmentId: Int!) {
    assignEquipmentToBag(bagId: $bagId, equipmentId: $equipmentId) {
      bag {
        id
      }
      equipment {
        id
      }
    }
  }
`;

export const UPDATE_EQUIPMENT_ON_BAG = gql`
  mutation updateEquipmentOnBag($bagId: Int!, $equipmentId: Int!, $comments: String, $qualityGrade: String, $picture: String) {
    updateEquipmentOnBag(bagId: $bagId, equipmentId: $equipmentId, comments: $comments, qualityGrade: $qualityGrade, picture: $picture) {
      bag {
        id
      }
      equipment {
        id
      }
      comments
      qualityGrade
      picture
    }
  }
`;

export const REMOVE_EQUIPMENT_FROM_BAG = gql`
  mutation removeEquipmentFromBag($bagId: Int!, $equipmentId: Int!) {
    removeEquipmentFromBag(bagId: $bagId, equipmentId: $equipmentId) {
      bagId
      equipmentId
    }
  }
`;